import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from "@angular/core";
import { AppConfigService } from '@m4u-angular/configuration/app.config.service';
import devices from 'devextreme/core/devices';
import { BehaviorSubject } from 'rxjs';
import { ResourcesService } from './resources.service';
import { EnumLanguages, EnumScreenSizes } from "./sysenums.enum";
import { SysGlobals } from './sysglobals';
import { UiService } from './ui.service';

export type Orientation = 'landscape' | 'portrait';

@Injectable({
    providedIn: 'root',
})
export class ScreenService {

    private _currentScreenSize: EnumScreenSizes;
    private _currentOrientation: Orientation;
    private onScreenSizeChanged: BehaviorSubject<EnumScreenSizes> = new BehaviorSubject(this.GetScreenSize());
    readonly ScreenSize$ = this.onScreenSizeChanged.asObservable();
    public options = {
        showRefreshMessage: {
            size: false,
            orientation: false
        }
    };
    private showMessageHandler: any;

    public get Sizes() {
        return {
            'screen-x-small': this.breakpointObserver.isMatched(Breakpoints.XSmall),
            'screen-small': this.breakpointObserver.isMatched(Breakpoints.Small),
            'screen-medium': this.breakpointObserver.isMatched(Breakpoints.Medium),
            'screen-large': this.breakpointObserver.isMatched(Breakpoints.Large),
            'screen-x-large': this.breakpointObserver.isMatched(Breakpoints.XLarge)
        };
    }

    //Subscribe to size changes
    constructor(private breakpointObserver: BreakpointObserver,
        private uiService: UiService,
        private rc: ResourcesService) {
        this._currentOrientation = this.Orientation();
        this.breakpointObserver
            .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
            .subscribe(() => {
                const newSize = this.GetScreenSize();
                const orientation = this.Orientation();
                let shown = false;
                if (orientation !== this._currentOrientation) {
                    shown = this.processRefreshMessage('orientation');
                    this._currentOrientation = orientation;
                }

                if (newSize !== this._currentScreenSize) {
                    (!shown && this._currentScreenSize) && (shown = this.processRefreshMessage('size'));
                    this._currentScreenSize = newSize;
                    this.onScreenSizeChanged.next(this._currentScreenSize);
                }
                //
            });
    }

    //Return relevant screen size
    public GetScreenSize(): EnumScreenSizes {
        if (this.breakpointObserver.isMatched(Breakpoints.XSmall)) return EnumScreenSizes.ScreenXSmall;
        if (this.breakpointObserver.isMatched(Breakpoints.Small)) return EnumScreenSizes.ScreenSmall;
        if (this.breakpointObserver.isMatched(Breakpoints.Medium)) return EnumScreenSizes.ScreenMedium;
        if (this.breakpointObserver.isMatched(Breakpoints.Large)) return EnumScreenSizes.ScreenLarge;
        if (this.breakpointObserver.isMatched(Breakpoints.XLarge)) return EnumScreenSizes.ScreenXLarge;
    }

    public IsRTL(): boolean {
        return (SysGlobals.Language == EnumLanguages.Hebrew);
    }

    public IsMobile() {
        // var size = this.GetScreenSize();
        // return size == EnumScreenSizes.ScreenXSmall;
        const device = devices.current();
        return device.deviceType === 'phone';
    }

    public IsDesktop() {
        // var size = this.GetScreenSize();
        // if (this.appConfigService.AppConfig.SupportLegacyDisplaySizes) {
        //     return !this.IsMobile();
        // } else {
        //     return size == EnumScreenSizes.ScreenLarge || size == EnumScreenSizes.ScreenXLarge;
        // }
        const device = devices.current();
        return device.deviceType === 'desktop';
    }

    public IsTablet() {
        // var size = this.GetScreenSize();
        // return size == EnumScreenSizes.ScreenSmall || size == EnumScreenSizes.ScreenMedium;
        const device = devices.current();
        return device.deviceType === 'tablet';
    }

    public Orientation(): Orientation {
        const orientation = devices.orientation();
        return orientation;
    }

    public IsPrintMode(): boolean {
        return window.matchMedia('print').matches;
    }

    public LogDeviceInfo() {
        const device = devices.current();
        console.log(device);
    }

    public IsWideScreen() {
        const screenSize = this.GetScreenSize();
        return (screenSize === EnumScreenSizes.ScreenLarge || screenSize === EnumScreenSizes.ScreenXLarge);
    }

    public IsMediumScreen() {
        const screenSize = this.GetScreenSize();
        return (screenSize === EnumScreenSizes.ScreenMedium);
    }

    processRefreshMessage = (mode: 'size' | 'orientation') => {
        if (this.showMessageHandler) {
            clearTimeout(this.showMessageHandler);
            this.showMessageHandler = null;
        }

        let message;
        if (this.options?.showRefreshMessage?.size && mode === 'size') {
            message = this.rc.RC('msgScreenSizeChangedRefresh');
        } else if (this.options?.showRefreshMessage?.orientation && mode === 'orientation') {
            message = this.rc.RC('msgOrientationChangedRefresh');
        }

        message && (this.showMessageHandler = setTimeout(() => {
            this.uiService.InfoMessage(message);
            this.showMessageHandler = null;
        }, 3000));

        return !!message;
    };
}
